import script from "./PricingModeBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingModeBadge.vue?vue&type=script&setup=true&lang=js"

import "./PricingModeBadge.vue?vue&type=style&index=0&id=70065b7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70065b7a"]])

export default __exports__